module.exports = __webpack_public_path__ + "static/media/farm_spray.8d650e0e.png";